import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "../scss/posts.scss";

export default function AzureCourse() {
  const nameExt = " | charlie-gp";
  const [postTitle, postDate, readTime] = [
    "It's Never Too Late",
    "Nov. 12, 2022",
    "3min. read",
  ];

  return (
    <div id="posts">
      <Helmet>
        <title>{postTitle + nameExt}</title>
      </Helmet>
      <div id="post-date">
        <small>
          {postDate} &nbsp;&bull;&nbsp; {readTime} &nbsp;&bull;&nbsp;{" "}
          <Link to="/blog/">Blog</Link>
        </small>
      </div>

      <p id="post-title">{postTitle}</p>

      <br />
      <p className="post-sect">Evolution</p>
      <p>
        Tech is really fast evolving, new stack, new means, and the way that you
        used to is deprecated. Well, that's the good thing about tech, there is
        always new and therefore, there is always a new opportunity.
      </p>

      <br />
      <p className="post-sect">The Advantage</p>
      <p>
        Things that are new to you is like Adrenaline, they keeping you awake.
        New tech is always exciting and everybody is learning. One of the most
        important factor of having an experience is a base-concept. It helps you
        to adapt on new tools or stack. Another one, coding experience is
        getting better and better in terms of the way how it simplifies things
        for us.
      </p>

      <br />
      <p className="post-sect"></p>
      <p className="text-end">
        <a href="#root">
          <i className="bi-arrow-up"></i> Back to top
        </a>
      </p>
    </div>
  );
}
